import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { TabelaComponent } from './tabela/tabela.component';
import { LoadingComponent } from './loading/loading.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";
import { NotificacaoComponent } from './notificacao/notificacao.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { DashboardAdvogadoComponent } from './dashboards/dashboard-advogado/dashboard-advogado.component';
import { LoginLawservicesComponent } from './login/login-lawservices/login-lawservices.component';
import { LoginImedComponent } from './login/login-imed/login-imed.component';
import { CadastroImedComponent } from './cadastro-novo-cliente/cadastro-imed/cadastro-imed.component';
import { CadastroLawservicesComponent } from './cadastro-novo-cliente/cadastro-lawservices/cadastro-lawservices.component';
import {NgxMaskDirective} from "ngx-mask";
import { FormularioComponent } from './login/formulario/formulario.component';
import { CadastroFormularioComponent } from './cadastro-novo-cliente/cadastro-formulario/cadastro-formulario.component';
import { InfoSaasCadastroComponent } from './cadastro-novo-cliente/info-saas-cadastro/info-saas-cadastro.component';
import {MatTooltip} from "@angular/material/tooltip";
import { CalendarioComponent } from './calendario/calendario.component';
import { CrmDashboardListComponent } from './crm-dashboard-list/crm-dashboard-list.component';
import { KanbamComponent } from './kanbam/kanbam.component';
import { CadastroNovoAtendimentoComponent } from './cadastro-novo-atendimento/cadastro-novo-atendimento.component';
import {NgSelectModule} from "@ng-select/ng-select";
import { CadastroNovoContatoComponent } from './cadastro-novo-contato/cadastro-novo-contato.component';
import { DetalhesClientesComponent } from './detalhes-clientes/detalhes-clientes.component';
import { MudarSenhaComponent } from './mudar-senha/mudar-senha.component';
import { AlterarStatusAgendamentoComponent } from './alterar-status-agendamento/alterar-status-agendamento.component';
import { AtendimentoDetalhesComponent } from './atendimento-detalhes/atendimento-detalhes.component';
import { DetalhesTarefasComponent } from './detalhes-tarefas/detalhes-tarefas.component';
import { NovoCompromissoComponent } from '../../modules/trabalho/agenda/componentes/novo-compromisso/novo-compromisso.component';
import { LeadNovoDocumentoComponent } from './lead-novo-documento/lead-novo-documento.component';

@NgModule({
    declarations: [
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        TabelaComponent,
        LoadingComponent,
        BreadcrumbComponent,
        NotificacaoComponent,
        FeedbackComponent,
        TutorialComponent,
        DashboardAdvogadoComponent,
        LoginLawservicesComponent,
        LoginImedComponent,
        CadastroImedComponent,
        CadastroLawservicesComponent,
        FormularioComponent,
        CadastroFormularioComponent,
        InfoSaasCadastroComponent,
        CalendarioComponent,
        CrmDashboardListComponent,
        KanbamComponent,
        CadastroNovoAtendimentoComponent,
        CadastroNovoContatoComponent,
        DetalhesClientesComponent,
        MudarSenhaComponent,
        AlterarStatusAgendamentoComponent,
        AtendimentoDetalhesComponent,
        DetalhesTarefasComponent,
        // moved from AgendaModule to break circular dependency
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        NovoCompromissoComponent,
        LeadNovoDocumentoComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxPaginationModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        MatTooltip,
        NgSelectModule
    ],
    exports: [
        LoadingComponent,
        HeaderComponent,
        SidebarComponent,
        BreadcrumbComponent,
        TabelaComponent,
        FeedbackComponent,
        NotificacaoComponent,
        TutorialComponent,
        DashboardAdvogadoComponent,
        LoginLawservicesComponent,
        LoginImedComponent,
        CadastroLawservicesComponent,
        CadastroImedComponent,
        KanbamComponent,
        CadastroNovoAtendimentoComponent,
        CalendarioComponent,
        CadastroNovoContatoComponent,
        MudarSenhaComponent,
        AlterarStatusAgendamentoComponent,
        DetalhesClientesComponent,
        AtendimentoDetalhesComponent,
        DetalhesTarefasComponent,
        NovoCompromissoComponent,
        LeadNovoDocumentoComponent
    ]
})
export class ComponentesModule { }
